
// SVG Icon: disable
export default { id: "terriajs-disable" };
export const id = "terriajs-disable";
export const name = "disable";
